module.exports = __webpack_public_path__ + "img/_icon-usps-close-x.abb1b75f.svg";